module.exports = __webpack_public_path__ + "media/images/6-fc2129509e7be367bb3824d3ba90fe56.png";